module.exports = __webpack_public_path__ + "static/media/kernel-panic.77f78719.png";